<template>
    <div class="service wid100" >
      <div class="swiper-container service_swiper"  ref="Node">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="https://cyvideo.i-oranges.com/home/7-1.jpg" class="wid100" alt=""/>
          </div>
          <div class="swiper-slide">
            <img src="https://cyvideo.i-oranges.com/home/7-2.jpg" class="wid100" alt=""/>
          </div>

        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
<!--        <div class="swiper-button-prev add_button-prev add_button-prev-bg1"></div>-->
<!--        <div class="swiper-button-next add_button-next add_button-prev-bg1"></div>-->
      </div>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
  name: "ServiceComponent",
  data(){
    return{
      service_url:"",
      cb: {
        imgUrlMin: 'https://cyvideo.i-oranges.com/home/7-1.jpg',
        imgUrlMax: 'https://cyvideo.i-oranges.com/home/7-2.jpg'
      }

      ,
    }
  },
  methods:{

  },
  mounted() {
    if(this.$parent.$options.name == 'index'){
      this.service_url = this.cb.imgUrlMin;
    }else{
      this.service_url = this.cb.imgUrlMax;
    }
    this.mySwiper = new Swiper('.service_swiper', {
      loop: true, // 循环模式
      pagination: {
        el: '.swiper-pagination', // 分页器
        clickable: true,
      },
      // parallax : true,

      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,

      },
      // effect:"fade",

      speed: 2500,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides : true,
      watchSlidesProgress : true,
      navigation: {
        nextEl: '.swiper-button-next', // 下一页按钮
        prevEl: '.swiper-button-prev', // 上一页按钮
      },
    });
  }
}
</script>

<style scoped>
  .service .swiper-pagination{ z-index: 2 !important;}
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponent.vue